import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa'; // Import Font Awesome close icon

function TopHeader({ plans }) {
  const [isVisible, setIsVisible] = useState(null);
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    const headerClosed = localStorage.getItem('headerClosed');
    setIsVisible(headerClosed !== 'true'); 

    const calculateTimeLeft = () => {
      const now = new Date();
      const midnight = new Date();
      midnight.setHours(24, 0, 0, 0); 
      const difference = midnight - now;

      if (difference > 0) {
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / (1000 * 60)) % 60);
        const seconds = Math.floor((difference / 1000) % 60);

        setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
      } else {
        setTimeLeft("Offer expired");
      }
    };

    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false); 
    localStorage.setItem('headerClosed', 'true'); 
  };

  if (isVisible === null || !isVisible) return null;

  return (
<div
  className="flex flex-wrap items-center justify-center p-3 py-7 text-center text-sm md:text-base lg:text-lg relative bg-fuchsia-200"
  // style={{ backgroundColor: "#eceb98" }}
>
  <span className="flex flex-wrap items-center justify-center text-gray-900">
    <b className="mr-2">Get up to {plans?.savings}% off</b>  
    on subscriptions! Enjoy the best deals  
    starting at just ${plans?.price} from the original price of {plans?.cancelledMRP}.
    <br />
    <b className="font-semibold ml-2 text-xl ">{timeLeft} left!</b>
  </span>

  {/* Close Button */}
  <button
    type="button"
    className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-800 hover:text-gray-600"
    aria-label="Close"
    onClick={handleClose}
  >
    <FaTimes size={16} />
  </button>
</div>

  );
}

export default TopHeader;
